import React from "react";
import Image from "next/image";

import { CookBookWrap, FirstHalf, SecondHalf, Title, Text, TextTitle, FirstBox, SecondBox } from "./styled";

const CookBook = () => {
  return (
    <CookBookWrap>
      <Title>
        One amazing platform
        <br />
        for the home kitchen
      </Title>
      <FirstHalf>
        <Text>
          <TextTitle>iTunes for recipes</TextTitle>
          One place for customers to buy, save and share all of your content. Ad free.
        </Text>
        <Text>
          <TextTitle>Show customers how its done</TextTitle>
          Help your biggest fans and customers cook with rich step-by-step and video options, built right into Foody
          recipe creation tools.
        </Text>
        <Text>
          <TextTitle>Pricing that customers understand</TextTitle>
          Paid recipes start at $0.99 with collections priced at a slight discount per-recipe (for example: a 10 recipes
          collection is priced at $7.99)
        </Text>
        <Text>
          <TextTitle>Global reach</TextTitle>
          You have fans all over the world. Sell your content to them wherever they are.
        </Text>
      </FirstHalf>
      <SecondHalf>
        <FirstBox>
          <Image src={`/images/cookbook1.png`} alt="cookbook 1" objectFit="cover" layout="fill" quality={100} />
        </FirstBox>
        <SecondBox>
          <Image src={`/images/cookbook3.png`} alt="cookbook 3" objectFit="cover" layout="fill" quality={100} />
        </SecondBox>
      </SecondHalf>
    </CookBookWrap>
  );
};

export default CookBook;
